export const Reveal = ({ children, delay = 0, className = "" }) => (
  <div className="animate-fade-up" style={{ animationDelay: `${delay}ms` }}>
    <div className={className}>{children}</div>
  </div>
);

export const SectionHeading = ({ overline, title, subtitle, light = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {overline && <p className="overline mb-3">{overline}</p>}
    <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight ${light ? "text-white" : "text-brand-navy"}`}>
      {title}
    </h2>
    {subtitle && <p className={`mt-4 text-base leading-relaxed ${light ? "text-white/70" : "text-brand-ink/70"}`}>{subtitle}</p>}
  </div>
);
